// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d545d048","622":"ca383a6b"}[chunkId] + ".chunk.js";
};